module.exports = __webpack_public_path__ + "static/img/charge-coupon-item.0992281.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/coupon/charge-coupon-item.png
// module id = 1Tbj
// module chunks = 4